
import {deep_copy} from "../../lib/js-utils";
import superagent from "superagent";
import {authorize} from "../helper/authorize-token";

const IRR_SET_LOADING = "IRR_SET_LOADING";
const IRR_LOAD = "IRR_LOAD";

const loadIRRScores = () => {
  return (dispatch, getState) => {
    dispatch({
      type: IRR_SET_LOADING,
      loading: true,
    })
    dispatch({
      type: IRR_LOAD,
      payload: superagent
        .post("/api/dashboard/admin-irr-scores")
        .use(authorize(getState())),
    })
  }
}

const DEFAULT_STATE = {
  loading: false,
}

const adminIRRReducer = (state = DEFAULT_STATE, action) => {

  const new_state = deep_copy(state);
  let response;

  switch(action.type) {

    case IRR_LOAD + "_FULFILLED":
      response = action.payload.body.data;
      new_state.loading = false;
      new_state.category = response.category_lut;
      new_state.scores = response.scores;
      return new_state;
    case IRR_SET_LOADING:
      new_state.loading = action.loading;
      return new_state;
    default:
      return new_state;
  }
}

export { adminIRRReducer, loadIRRScores };
